import * as React from "react";

function CodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m414.9 31.11-144 463.99c-4.8 12.7-17.4 19.7-30 15.8-12.7-4.8-19.8-17.4-15.8-30l144-464.01c3.9-12.664 17.4-19.742 30-15.813 12.7 3.929 19.8 17.373 15.8 30.033zm89.5 87.39 128 120c4.9 4.5 7.6 10.9 7.6 16.6 0 7.5-2.7 13-7.6 18.4l-128 120c-9.7 9.1-24.8 8.6-33.9-1.1-9.1-9.7-8.6-24.8 1.1-33.9l109.3-103.4-109.3-101.6c-9.7-9.1-10.2-24.2-1.1-33.9s24.2-10.2 33.9-1.1zm-336 35L59.09 255.1 168.4 358.5c9.7 9.1 10.2 24.2 1.1 33.9s-24.2 10.2-33.9 1.1L7.585 273.5C2.746 268.1 0 262.6 0 255.1c0-5.7 2.746-12.1 7.585-16.6l128.015-120c9.7-9.1 24.8-8.6 33.9 1.1 9.1 9.7 8.6 24.8-1.1 33.9z"
  }));
}

const ForwardRef = React.forwardRef(CodeIcon);
export default ForwardRef;